import { render, staticRenderFns } from "./file-id.vue?vue&type=template&id=74855bed&scoped=true&"
import script from "./file-id.vue?vue&type=script&lang=ts&"
export * from "./file-id.vue?vue&type=script&lang=ts&"
import style0 from "./file-id.vue?vue&type=style&index=0&id=74855bed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74855bed",
  null
  
)

export default component.exports